import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const isValidEmail = (email: string) : boolean => {
  if (email.length === 0) {
    return false
  }
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email)
}

//Cross-browser implementation to check if an element has a certain class
export const hasClass = (element: HTMLElement, className: string) : boolean => {
  return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1
}


export const formatWithTz = (datetime: string | Date, tz: string, format = 'MMMM D, YYYY h:mm A') : string => {
  return dayjs.tz(datetime, tz).format(format)
}

export const convertHourToUTC = (hour: number): number => {
  const now = dayjs().toDate()
  now.setHours(hour)

  const hourUTC = dayjs.utc(now).hour()

  return hourUTC
}

export const convertHourToLocalTime = (hour: number): number => {
  const nowUTC = dayjs().utc().set('hour', hour)

  const hourUTC = dayjs(nowUTC).local().hour()

  return hourUTC
}

export const convertDateToLocalTime = (date: Date, format = 'MMMM D, YYYY h:mm A'): string => {
  console.log(date, 'date')

  const local = dayjs.utc(date).local().format(format)
  console.log(local, 'local')

  return local
}
